import { createContext, ReactNode, useContext, useState } from 'react';
import { createGraphQLClient } from '~src/graphql';

import { Client, Provider as GraphQLProvider } from 'urql';

export type GraphQLClientContext = {
  resetClient: () => void;
};

const GraphQLContext = createContext<GraphQLClientContext>({
  resetClient: () => {},
});

export const GraphQLContextProvider = ({ children }: { children?: ReactNode }) => {
  const [client, setClient] = useState<Client>(createGraphQLClient());

  return (
    <GraphQLContext.Provider value={{ resetClient: () => setClient(createGraphQLClient()) }}>
      <GraphQLProvider value={client}>{children}</GraphQLProvider>
    </GraphQLContext.Provider>
  );
};

export const useGraphQLClient = () => useContext<GraphQLClientContext>(GraphQLContext);
